function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.41,136.84c-13-20.68-29.06-39.37-48.52-54.7-66.9-52.7-167-57.37-245.3-30.53-23.14,7.93-45.23,19.21-64.12,34.88-13.73,11.39-25.49,24.93-39.18,36.37-14.38,12-32.16,12.28-50.22,11.28q-39-2.16-77.81-6.59c-22.54-2.58-43.77-6.8-66.1-.58C63.46,137.5,33.58,170.34,22,207.14c-14.5,46.22-4.58,97.12,15.38,141.26,6.91,15.28,15.21,30.2,18.81,46.64,3.74,17.09,11.29,34.55,24,47.24,14.85,14.77,38,19.93,58.09,23.74,38.87,7.4,78.86,3.31,117-6,36-8.76,72.69-23.9,110.57-24.16,42.5-.28,82.91,17.09,124.68,24.93,37.38,7,76.05,6.65,113.46,0,33.94-6,71-15.62,95.89-41,65.82-67.06,43.57-179.61,7.26-255.64A266.66,266.66,0,0,0,692.41,136.84Z",
    style: {
      fill: "#3D4447"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.41,136.84c-13-20.68-29.06-39.37-48.52-54.7-66.9-52.7-167-57.37-245.3-30.53-23.14,7.93-45.23,19.21-64.12,34.88-13.73,11.39-25.49,24.93-39.18,36.37-14.38,12-32.16,12.28-50.22,11.28q-39-2.16-77.81-6.59c-22.54-2.58-43.77-6.8-66.1-.58C63.46,137.5,33.58,170.34,22,207.14c-14.5,46.22-4.58,97.12,15.38,141.26,6.91,15.28,15.21,30.2,18.81,46.64,3.74,17.09,11.29,34.55,24,47.24,14.85,14.77,38,19.93,58.09,23.74,38.87,7.4,78.86,3.31,117-6,36-8.76,72.69-23.9,110.57-24.16,42.5-.28,82.91,17.09,124.68,24.93,37.38,7,76.05,6.65,113.46,0,33.94-6,71-15.62,95.89-41,65.82-67.06,43.57-179.61,7.26-255.64A266.66,266.66,0,0,0,692.41,136.84Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.65,37.55S434.1,25.2,422.43,25.88s-15.78,8.24-19.21,13.73-4.8,2.06-13.72-.69-13,2.06-15.1,6.86-1.37,1.37-9.6,0-8.45,3.54-13.73,6.18c-4.3,2.15-5.22,2.24-10,.95-5.93-1.6-7.87-.27-9.24,2.48H471.05s-2.64-11-8.82-13.72S447.82,44.41,441.65,37.55Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.19,65.05s-4.2-6.87-10.7-6.49-8.78,4.59-10.69,7.64-2.67,1.15-7.64-.38-7.25,1.14-8.4,3.82-.76.76-5.35,0-4.69,2-7.63,3.43c-2.4,1.2-2.91,1.25-5.55.53-3.3-.89-4.38-.14-5.15,1.38h77.47s-1.47-6.11-4.91-7.63S199.62,68.87,196.19,65.05Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.4,143.64s-2.19-3.58-5.57-3.38-4.57,2.39-5.57,4-1.39.6-4-.2a3.22,3.22,0,0,0-4.37,2c-.6,1.39-.4.4-2.79,0s-2.45,1-4,1.79a3,3,0,0,1-2.89.28c-1.72-.47-2.28-.08-2.68.71h40.35s-.76-3.18-2.55-4S721.19,145.63,719.4,143.64Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.39,69s-2.19-3.58-5.57-3.38-4.58,2.39-5.57,4-1.4.59-4-.2a3.22,3.22,0,0,0-4.38,2c-.59,1.39-.4.39-2.78,0s-2.45,1-4,1.79a3,3,0,0,1-2.89.27c-1.72-.46-2.28-.07-2.68.72h40.35s-.76-3.18-2.55-4S465.18,71,463.39,69Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-190"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "25.99 381.76 57.63 381.76 57.63 95.64 140.85 95.64 140.85 231.82 158.73 231.82 158.73 401.02 179.37 401.02 179.37 148.46 217.88 148.46 217.88 46.13 279.78 46.13 279.78 234.57 303.17 234.57 303.17 159.61 355.44 159.61 355.44 176.11 400.14 176.11 400.14 398.95 418.02 398.95 418.02 358.37 466.86 358.37 466.86 398.26 490.24 398.26 490.24 197.44 569.33 197.44 569.33 385.88 592.03 385.88 592.03 123.16 619.54 123.16 619.54 75.01 633.3 75.01 633.3 47.5 655.31 47.5 655.31 225.63 691.07 225.63 691.07 395.51 718.58 395.51",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.63,
    y: 86.7,
    width: 83.22,
    height: 8.94,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.13,
    y: 148.46,
    width: 38.75,
    height: 4.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 46.13,
    width: 62.08,
    height: 4.4,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.09,
    y: 150.26,
    width: 9.04,
    height: 9.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.11,
    y: 154.18,
    width: 4.52,
    height: 5.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.44,
    y: 176.11,
    width: 44.85,
    height: 5.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.24,
    y: 193.35,
    width: 79.08,
    height: 4.09,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.57,
    y: 185.21,
    width: 31.34,
    height: 8.14,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "535.27 185.51 535.27 177.98 558.17 177.98 558.17 193.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "384.35 173.86 384.35 112.98 456.83 112.98 456.83 163.43 481.76 163.43 481.76 77.61 561.78 77.61 561.78 181.4 586.72 181.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "332.16 143.71 332.16 76.45 282.87 76.45",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "176.76 160.53 160.52 160.53 160.52 113.56 144.86 113.56",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "54.99 147.77 41.65 147.77 41.65 330.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "611.07 114.14 611.07 92.1 618.03 92.1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "658.04 92.68 682.97 92.68 682.97 184.88 725.3 184.88 725.3 291.57",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 59.05,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 59.05,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 59.05,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 59.05,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 59.05,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 79.64,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 79.64,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 79.64,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 79.64,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 79.64,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 100.22,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 100.22,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 100.22,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 100.22,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 100.22,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 120.81,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 120.81,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 120.81,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 120.81,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 120.81,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 141.39,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 141.39,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 141.39,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 141.39,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 141.39,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 161.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 161.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 161.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 161.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 161.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 161.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 161.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 161.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 181.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 181.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 181.98,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 201.99,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 201.99,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 201.99,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 221.99,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 221.99,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 221.99,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 242,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 242,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 242,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 262,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 262,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 262,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 282.01,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 282.01,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 282.01,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 302.01,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 302.01,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 302.01,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 322.02,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 322.02,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 322.02,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 342.02,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 342.02,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 342.02,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.38,
    y: 362.03,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 362.03,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 362.03,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.25,
    y: 244.32,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.45,
    y: 244.32,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.25,
    y: 264.32,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.45,
    y: 264.32,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.25,
    y: 284.33,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.45,
    y: 284.33,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.25,
    y: 304.33,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.45,
    y: 304.33,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.25,
    y: 324.34,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.45,
    y: 324.34,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.25,
    y: 344.34,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.45,
    y: 344.34,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.25,
    y: 364.35,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.45,
    y: 364.35,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 182.56,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 182.56,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 182.56,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 182.56,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 182.56,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 203.15,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 203.15,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 203.15,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 203.15,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 203.15,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 223.73,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 223.73,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 223.73,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 223.73,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 223.73,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 244.32,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 244.32,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 244.32,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 244.32,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 244.32,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 264.9,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 264.9,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 264.9,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 264.9,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 264.9,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 285.49,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 285.49,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 285.49,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 285.49,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 285.49,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 306.07,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 306.07,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 306.07,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 306.07,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 306.07,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 326.66,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 326.66,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 326.66,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 326.66,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 326.66,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 347.24,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 347.24,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 347.24,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 347.24,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 347.24,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.57,
    y: 368.41,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.77,
    y: 368.41,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.97,
    y: 368.41,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 368.41,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.37,
    y: 368.41,
    width: 6.22,
    height: 12.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.88,
    y1: 152.99,
    x2: 217.88,
    y2: 401.17,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.02,
    y1: 164.59,
    x2: 313.02,
    y2: 397.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.2,
    y1: 164.59,
    x2: 325.2,
    y2: 397.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.38,
    y1: 164.59,
    x2: 337.38,
    y2: 397.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.55,
    y1: 164.59,
    x2: 349.55,
    y2: 397.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.73,
    y1: 187.78,
    x2: 361.73,
    y2: 397.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.91,
    y1: 187.78,
    x2: 373.91,
    y2: 397.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.09,
    y1: 187.78,
    x2: 386.09,
    y2: 397.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 108.92,
    x2: 136.75,
    y2: 108.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 124,
    x2: 136.75,
    y2: 124,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 139.07,
    x2: 136.75,
    y2: 139.07,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 154.15,
    x2: 136.75,
    y2: 154.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 169.22,
    x2: 136.75,
    y2: 169.22,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 184.3,
    x2: 136.75,
    y2: 184.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 199.38,
    x2: 136.75,
    y2: 199.38,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 214.45,
    x2: 136.75,
    y2: 214.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 229.53,
    x2: 136.75,
    y2: 229.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 244.61,
    x2: 136.75,
    y2: 244.61,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 259.68,
    x2: 136.75,
    y2: 259.68,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 274.76,
    x2: 136.75,
    y2: 274.76,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 289.84,
    x2: 136.75,
    y2: 289.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 304.91,
    x2: 136.75,
    y2: 304.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 319.99,
    x2: 136.75,
    y2: 319.99,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 335.06,
    x2: 136.75,
    y2: 335.06,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 350.14,
    x2: 136.75,
    y2: 350.14,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 365.22,
    x2: 136.75,
    y2: 365.22,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 380.29,
    x2: 136.75,
    y2: 380.29,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 395.37,
    x2: 136.75,
    y2: 395.37,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 410.45,
    x2: 136.75,
    y2: 410.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.64,
    y1: 86.31,
    x2: 70.64,
    y2: 413.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 150.67 609.33 150.67 609.33 158.79 592.51 158.79",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "690.51 241.71 671.38 241.71 671.38 249.82 690.51 249.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "690.51 260.84 671.38 260.84 671.38 268.96 690.51 268.96",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "690.51 279.98 671.38 279.98 671.38 288.1 690.51 288.1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "690.51 299.11 671.38 299.11 671.38 307.23 690.51 307.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "690.51 318.25 671.38 318.25 671.38 326.37 690.51 326.37",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "690.51 337.38 671.38 337.38 671.38 345.5 690.51 345.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "690.51 356.52 671.38 356.52 671.38 364.64 690.51 364.64",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "690.51 375.65 671.38 375.65 671.38 383.77 690.51 383.77",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 172.7 609.33 172.7 609.33 180.82 592.51 180.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 194.74 609.33 194.74 609.33 202.86 592.51 202.86",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 216.77 609.33 216.77 609.33 224.89 592.51 224.89",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 238.81 609.33 238.81 609.33 246.93 592.51 246.93",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 260.84 609.33 260.84 609.33 268.96 592.51 268.96",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 282.88 609.33 282.88 609.33 291 592.51 291",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 304.91 609.33 304.91 609.33 313.03 592.51 313.03",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 326.95 609.33 326.95 609.33 335.06 592.51 335.06",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "592.51 348.98 609.33 348.98 609.33 357.1 592.51 357.1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 203.44,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 215.61,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 227.79,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 239.97,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 252.14,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 264.32,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 276.5,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 288.68,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 300.85,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 313.03,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 325.21,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 337.38,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 349.56,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 361.74,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 373.91,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 386.09,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.78,
    y: 398.27,
    width: 73.06,
    height: 6.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.77,
    y1: 131.53,
    x2: 619.77,
    y2: 400.59,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 634.84,
    y1: 80.51,
    x2: 634.84,
    y2: 400.59,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.94,
    y: 339.12,
    width: 36.53,
    height: 19.14,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.63,
    y: 305.49,
    width: 19.14,
    height: 33.63,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.78,
    y1: 234.58,
    x2: 279.78,
    y2: 400.71,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.61,
    y1: 216.37,
    x2: 400.9,
    y2: 216.37,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.61,
    y1: 226.28,
    x2: 400.9,
    y2: 226.28,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.86,
    y: 233.71,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.55,
    y: 233.71,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.24,
    y: 233.71,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.93,
    y: 233.71,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.62,
    y: 233.71,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.86,
    y: 249.07,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.55,
    y: 249.07,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.24,
    y: 249.07,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.93,
    y: 249.07,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.62,
    y: 249.07,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.86,
    y: 264.44,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.55,
    y: 264.44,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.24,
    y: 264.44,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.93,
    y: 264.44,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.62,
    y: 264.44,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.86,
    y: 292.19,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.55,
    y: 292.19,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.24,
    y: 292.19,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.93,
    y: 292.19,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.62,
    y: 292.19,
    width: 13.53,
    height: 9.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-190"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 14.91,
    y1: 418.53,
    x2: 738.19,
    y2: 418.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Limousine--inject-190"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150.24,
    cy: 386.35,
    r: 32.18,
    transform: "translate(-34.09 15.05) rotate(-5.15)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635.75,
    cy: 386.35,
    r: 32.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.44,390.4l544.09,3.76L697,393l4-16s3.31-13.22-4.63-23.14-23.14-19.17-35.7-16.53-556.68,0-556.68,0-29.75,7.27-35,29.09S80.44,390.4,80.44,390.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.18,
    cy: 386.35,
    r: 32.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.18,364a22.38,22.38,0,1,0,22.38,22.38A22.38,22.38,0,0,0,117.18,364Zm18.17,15.95-8.86,1.76a10.66,10.66,0,0,0-1-1.67l5.46-7.22A19.41,19.41,0,0,1,135.35,379.92Zm-8.86-10.47L121,376.67a9.28,9.28,0,0,0-1.09-.36v-9A19.18,19.18,0,0,1,126.49,369.45Zm-12.08-2.18v9a10.61,10.61,0,0,0-1.76.66l-6-6.81A19.24,19.24,0,0,1,114.41,367.27Zm-11.88,6.54,6,6.8a10.57,10.57,0,0,0-1.14,2.31l-9-.6A19.35,19.35,0,0,1,102.53,373.81Zm-1.53,23a19.09,19.09,0,0,1-3-9l9,.6a10.18,10.18,0,0,0,.83,2.44Zm3.64,4.16,6.8-5.94c.22.14.45.28.69.41L110,404.25A19.15,19.15,0,0,1,104.64,401Zm12.54,4.65c-.61,0-1.21,0-1.8-.09l2.13-8.8a10.19,10.19,0,0,0,1.57-.16l4,8.14A19.26,19.26,0,0,1,117.18,405.64ZM128,402.31l-4-8.14a9.56,9.56,0,0,0,.9-.9l8.12,4A19.25,19.25,0,0,1,128,402.31Zm-.6-14a9.75,9.75,0,0,0,.15-1.21l8.86-1.77c0,.34.05.67.05,1a19.27,19.27,0,0,1-.95,6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.22,
    cy: 386.35,
    r: 32.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.22,364a22.38,22.38,0,1,0,22.37,22.38A22.38,22.38,0,0,0,663.22,364Zm18.17,15.95-8.86,1.76a10.66,10.66,0,0,0-1-1.67l5.46-7.22A19.41,19.41,0,0,1,681.39,379.92Zm-8.86-10.47-5.46,7.22a9.93,9.93,0,0,0-1.09-.36v-9A19.25,19.25,0,0,1,672.53,369.45Zm-12.08-2.18v9a11.07,11.07,0,0,0-1.77.66l-5.95-6.81A19.34,19.34,0,0,1,660.45,367.27Zm-11.88,6.54,5.95,6.8a10.57,10.57,0,0,0-1.14,2.31l-9-.6A19.14,19.14,0,0,1,648.57,373.81Zm-1.54,23a19.19,19.19,0,0,1-3-9l9,.6a10.66,10.66,0,0,0,.84,2.44Zm3.65,4.16,6.8-5.94c.22.14.45.28.69.41L656,404.25A19.15,19.15,0,0,1,650.68,401Zm12.54,4.65c-.61,0-1.21,0-1.8-.09l2.13-8.8a10.19,10.19,0,0,0,1.57-.16l4,8.14A19.26,19.26,0,0,1,663.22,405.64Zm10.83-3.33-4-8.14a9.56,9.56,0,0,0,.9-.9l8.12,4A19.25,19.25,0,0,1,674.05,402.31Zm-.6-14a12.12,12.12,0,0,0,.15-1.21l8.86-1.77c0,.34,0,.67,0,1a19.27,19.27,0,0,1-1,6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.73,362c-3-1.81-8.72-4.82-8.72-4.82s-4.22-9.62-7.82-12.93A25.8,25.8,0,0,0,710,338.83c-1.5-.3-104.66-13.23-104.66-13.23s-51.73-28.28-57.44-31-17.15-6-22-5.72-179.85-3.3-179.85-3.3l-155.19-.31s-28.87,1.51-46,6.92S119,301.54,112.67,307s-13.84,12.63-13.84,12.63L34.47,326.2s-9.92,2.4-12,9.32S18.23,353,18.23,353s-5.71,1.81-6.31,5.72,1.8,21.05,3.3,22.25,20.15,3.31,20.15,3.31a19.75,19.75,0,0,0,9.93,4.21c4.91.7,26,1.59,35.14,1.95,0-.82-.07-1.63-.07-2.46,0-21.6,16.32-39.11,36.38-39.11S153.06,366.36,153,388c0,1-.05,2-.13,3.05l471.63,3.15a43.15,43.15,0,0,1,.05-6.22c1.78-21.6,19.48-39.11,39.55-39.11S699,366.36,697.24,388a43.46,43.46,0,0,1-.71,5h.5s30.37-3.3,33.08-3.61,7.22-8.12,8.12-13.53S739.73,363.79,736.73,362Z",
    style: {
      fill: "#3D4447",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.19,344.24H705.34A1.74,1.74,0,0,0,703.6,346v9.29a1.73,1.73,0,0,0,1.74,1.73H728S723.31,347.64,720.19,344.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.14,353.41h13.64v3.41H706.16c-1.82,0-2.3-1.62-2-3.41Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 736.73,
    y1: 361.99,
    x2: 691.21,
    y2: 361.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.54,
    y1: 356.98,
    x2: 91.78,
    y2: 356.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.46,356.75s14.12-16,38.89-13.19,34,27.78,34,44.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.34,363.47s14.59-20.37,37.5-18.29,28.94,17.36,28.94,17.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,364.16H153.59s6,10.74,5.42,26.89l465.52,3.11a43.15,43.15,0,0,1,.05-6.22A44.13,44.13,0,0,1,634,364.16Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.62,289.86s15.74,38.19,18.05,73.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.3,325.6H595s-29.4-18.85-38-23.71-25.46-11.34-31.71-11.57l.56-1.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.18,329.67s10.65,11.11,10.65,23.61-.7,29.4-3.94,38.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,286.85l.23,2.77s4.63,59.26,5.79,66.44-.47,32.87-.47,32.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551,303.05c-4.17-2.78-16.2-6.71-22.92-7.64s-17.59-2.31-21.06-2.31H492.7l-3.47.23-271.06-2.78s-30.79.23-35.88.93-25.23,4.16-31,9-7.64,21.07-7.64,21.07l359.25,4.63h85.88S555.2,305.83,551,303.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.6,325.91l22.28.29h85.88S555.2,305.83,551,303.05s-16.2-6.71-22.92-7.64-17.59-2.31-21.06-2.31H492.7l-3.47.23-17.67-.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551,303.05c-4.17-2.78-16.2-6.71-22.92-7.64s-17.59-2.31-21.06-2.31h-12.4l3.13,11.13s15.33-.87,22,2.31,20.83,14.17,20.83,14.17a9.94,9.94,0,0,0-2,3.77,3.09,3.09,0,0,0,.33,1.72h49.87S555.2,305.83,551,303.05Zm-20.28,1.18a33.77,33.77,0,0,1,10.71-.87c5.2.58,37,18.8,40.78,22l-24.87-.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.52,293.1H492.7l-3.47.23-21.12-.22c2.14,5.52,7.37,26.58,8.89,32.75l25.88.34h6.62C505.41,315,499,299.2,496.52,293.1Z",
    style: {
      fill: "#4c4c4c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,296.31c-3.83,1.23-7.15,2.64-9,4.19-5.79,4.86-7.64,21.07-7.64,21.07l12.75.16Z",
    style: {
      fill: "#4c4c4c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.8,292.12l-30.51-.31c2.2,7.79,6,25.09,7.63,32.4l31.51.41C378.32,314,373.51,297.79,371.8,292.12Z",
    style: {
      fill: "#4c4c4c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.46,290.85l-29-.3.2,32,33.48.44C251.07,313.16,248.42,296.7,247.46,290.85Z",
    style: {
      fill: "#4c4c4c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.61,
    y: 338.7,
    width: 17.36,
    height: 2.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.01,
    y: 332.91,
    width: 17.36,
    height: 2.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.6,342.86a6.94,6.94,0,0,1-1.16-5.32c.46-3.47,5.32-31.71,9-36.34a29.16,29.16,0,0,1,13.88-10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.47,326.2s-9.92,2.4-12,9.32S18.23,353,18.23,353H26s2.28-16.21,8.48-26.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.91,313.57a1.24,1.24,0,0,1-1.24-1.13l-1.45-15.33a1.24,1.24,0,0,1,1.13-1.35,1.23,1.23,0,0,1,1.35,1.12l1.45,15.33a1.24,1.24,0,0,1-1.12,1.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.67,313.57a1.24,1.24,0,0,1-1.24-1.13L231,297.11a1.24,1.24,0,0,1,2.47-.23l1.45,15.33a1.24,1.24,0,0,1-1.12,1.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.43,313.57a1.24,1.24,0,0,1-1.24-1.13l-1.44-15.33a1.24,1.24,0,0,1,2.47-.23l1.45,15.33a1.24,1.24,0,0,1-1.12,1.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.19,313.57a1.24,1.24,0,0,1-1.24-1.13l-1.44-15.33a1.24,1.24,0,0,1,2.47-.23l1.45,15.33a1.24,1.24,0,0,1-1.12,1.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,313.57a1.25,1.25,0,0,1-1.24-1.13l-1.44-15.33a1.24,1.24,0,0,1,2.47-.23l1.45,15.33a1.24,1.24,0,0,1-1.12,1.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.22,315.31a1.37,1.37,0,0,1-1.32-1.13l-2.53-15.33a1.14,1.14,0,0,1,1-1.36,1.36,1.36,0,0,1,1.44,1.12l2.53,15.33a1.15,1.15,0,0,1-1,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,315.31a1.37,1.37,0,0,1-1.32-1.13l-2.53-15.33a1.14,1.14,0,0,1,1-1.36,1.36,1.36,0,0,1,1.44,1.12l2.53,15.33a1.15,1.15,0,0,1-1,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.74,315.31a1.37,1.37,0,0,1-1.32-1.13l-2.53-15.33a1.14,1.14,0,0,1,1-1.36,1.36,1.36,0,0,1,1.44,1.12l2.53,15.33a1.14,1.14,0,0,1-1,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5,315.31a1.37,1.37,0,0,1-1.32-1.13l-2.53-15.33a1.14,1.14,0,0,1,1-1.36,1.36,1.36,0,0,1,1.44,1.12l2.53,15.33a1.14,1.14,0,0,1-1,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.26,315.31a1.37,1.37,0,0,1-1.32-1.13l-2.53-15.33a1.15,1.15,0,0,1,1-1.36,1.36,1.36,0,0,1,1.44,1.12l2.53,15.33a1.14,1.14,0,0,1-1,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.17,316.46a1.6,1.6,0,0,1-1.46-1.13L474.2,300a1,1,0,0,1,.86-1.35,1.58,1.58,0,0,1,1.57,1.12l4.51,15.33a1,1,0,0,1-.85,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.93,316.46a1.6,1.6,0,0,1-1.46-1.13L478,300a1,1,0,0,1,.86-1.35,1.57,1.57,0,0,1,1.57,1.12l4.51,15.33a1,1,0,0,1-.85,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.69,316.46a1.6,1.6,0,0,1-1.46-1.13L481.73,300a1,1,0,0,1,.85-1.35,1.57,1.57,0,0,1,1.57,1.12l4.51,15.33a1,1,0,0,1-.85,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.45,316.46a1.6,1.6,0,0,1-1.46-1.13L485.49,300a1,1,0,0,1,.85-1.35,1.59,1.59,0,0,1,1.58,1.12l4.5,15.33a1,1,0,0,1-.85,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.22,316.46a1.6,1.6,0,0,1-1.47-1.13L489.25,300a1,1,0,0,1,.85-1.35,1.59,1.59,0,0,1,1.58,1.12l4.5,15.33a1,1,0,0,1-.85,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.54,314.93s-1.16,7.52.29,9.55,5.21,6.07,9.26,6.36,5.2-2.32,4.63-3.76-1.16-7.23-4.05-9.55S574.15,314.64,571.54,314.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172,336.32l3.94,103.53a5.47,5.47,0,0,0-2.46,4.44c0,3,.74,9.12.74,9.12a8.74,8.74,0,0,0-1,2.71c-.25,1.48.49,6.41.49,6.41s5.43-2.47,8.14-1.73S193.41,466,193.41,466s3.45-6.65,3.7-9.86-2-8.63-2-10.6,6.41-96.38,6.41-96.38l8.13,92.68-1.48,6.41s-1.23,4.93-.74,6.41,1.48,9.62,1.48,9.62,4.44,2.46,8.88,1.47,14.79-4.19,14.79-4.19a68.33,68.33,0,0,1,0-7.39c.24-2.47-4-10.6-3.7-13.07s1.73-106.73,1.73-106.73H171.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.8,229.23s-24.53,6-25.13,7.18,9,40.55,9,40.55l-1.79,62.1s7.93,3.29,21.55,3.74,21.54-.15,28.27-1.35S232.79,338,232.79,338l-1.5-60.45s8.53-40.4,8.38-40.85-20.65-8.23-28.28-8.08S185.8,229.23,185.8,229.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.74,224.37l-2.14,2.47-3.14,2.54L180,237.46l6.88.3-5.38,4.34s6.43,12.12,10,16.61,9.14,15.17,9.14,15.17,7.62-13.08,10.31-16.22,7-10.92,8.53-12.87a23.34,23.34,0,0,0,2.54-4.34l-5.53-2.69,5.09-3s-6-5.54-6.89-7.63-1.19-3.59-2.84-3.44S189.74,224.37,189.74,224.37Z",
    style: {
      fill: "#4c4c4c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.74 224.37 200.63 273.88 212.42 224.97 189.74 224.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.74 224.37 193.38 240.95 200.93 231.93 208.52 241.15 212.42 224.97 189.74 224.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.74,217.82v6.55s10.89,7.46,11.19,7.56,11.49-7,11.49-7V215.6s-6.25,6-10,6.05S189.74,217.82,189.74,217.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.1 236.87 200.02 240.8 197.3 257.04 200.63 273.88 204.66 256.94 202.84 240.8 204.96 236.97 200.93 231.93 197.1 236.87",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.03,
    y: 246.59,
    width: 3.74,
    height: 1.32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.75,305.84l-4.19,2.25s-4.64,2.69-6.43,3.89-8.08,10.47-7.63,11.22a7.46,7.46,0,0,0,3,2.69c1,.3,3,1.65,5.09,1.95s4.49.74,7.18-1.2,6.28-7.63,6.73-8.38a24.67,24.67,0,0,1,2.85-2.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.67,236.41s1.64.3,3,4,6.43,46.54,6.28,48.78a9.19,9.19,0,0,1-1.79,4.34l-32,27.08-9.73-16s13.32-10.47,16.76-13.31,8.38-7.48,8.38-7.48l.45-8.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,306.14a42.72,42.72,0,0,0,5.23.45c.75-.15,4.34-.15,6.14,1.65a29.44,29.44,0,0,0,5.38,3.74s2.25.44.45,1.94-2.84,1.65-4.49,1.05a26.34,26.34,0,0,0-3-.9s4.79,3.14,5.69,4.64,3.14,2.84.15,4.49l-3,1.64a82.74,82.74,0,0,1-9.88.75c-3-.15-5.84-4.79-6.43-6.13a21.25,21.25,0,0,0-2.1-3.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.67,236.41s-1.65.3-3,4-6.43,46.54-6.28,48.78a9.16,9.16,0,0,0,1.8,4.34l32,27.08,9.72-16s-13.32-10.47-16.76-13.31-8.38-7.48-8.38-7.48l-.44-8.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.36,280.7a1.5,1.5,0,1,1-1.5-1.49A1.5,1.5,0,0,1,204.36,280.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.36,298.81a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,204.36,298.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.93,460.31s-4,5.18-6.66,8.63-3.2,6.16-.74,7.15,12.08,3,15.78.74a36.28,36.28,0,0,0,7.39-6.66l2.71-4.19s-2-2.71-7.88-5.67A11.21,11.21,0,0,0,174.93,460.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,460.31s3.94,5.18,6.65,8.63,3.21,6.16.74,7.15-12.08,3-15.78.74a36.28,36.28,0,0,1-7.39-6.66L213.51,466s2-2.71,7.89-5.67A11.22,11.22,0,0,1,232,460.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,199.16s-6.86-5.14-8.07-8,17.24-16.94,19.86-17.55,6.46-.6,8.47.61,18.45,15.32,18.15,17.34-8.87,8.87-8.87,8.87a19,19,0,0,0-13.71-6.15A27.08,27.08,0,0,0,186,199.16Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,188.27a26,26,0,0,0-18.86,7.92c1.89,1.66,3.64,3,3.64,3a27.08,27.08,0,0,1,15.83-4.84,19,19,0,0,1,13.71,6.15s1.28-1,2.88-2.4C215.47,194,209.82,188.4,201.23,188.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.32,198.79s.79,14.89,1.91,17.13,7.5,8.62,9.4,10.07,5.71,1.12,8,.12,8.84-7.62,9.74-11.87.9-16,.9-16a17.5,17.5,0,0,0-13.1-4.93C193.94,193.75,187.34,196,185.32,198.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.32,198.79a14.87,14.87,0,0,0,5.08,1.68c2.2.11,8.6-4.26,11.8-3.58s7.17,4.59,9.71,4.47a4.55,4.55,0,0,0,3.64-2,17,17,0,0,0-11.25-7.73C196.35,190.06,187.75,194.54,185.32,198.79Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.52,201a5.63,5.63,0,0,0-6.49,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.92,200.92a6.8,6.8,0,0,1,6.49.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.22,
    cy: 204.39,
    rx: 0.95,
    ry: 1.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.49,
    cy: 204.39,
    rx: 0.95,
    ry: 1.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "202.9 202.82 202.9 211.55 198.42 210.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,211.1a25.16,25.16,0,0,0-3.13,1.46,17.67,17.67,0,0,1-3.47,1.46c-.45.11-1.38.52,3.85,2s11.37-.86,11.59-1.74c0,0-.36.06-2.93-1.2a18.18,18.18,0,0,0-4.34-1.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.6,202.09s-2.42-2.63-3.73-.11-.1,4.14,1,5.65A8.21,8.21,0,0,0,186,210Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,202.09s2.42-2.63,3.73-.11.1,4.14-1,5.65a8.21,8.21,0,0,1-3.13,2.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.83c9e92b4cc798278d7c9782297373df.svg";
export { ForwardRef as ReactComponent };